import { render, staticRenderFns } from "./WidgetsDialogs.vue?vue&type=template&id=648ad7a0&scoped=true"
import script from "./WidgetsDialogs.vue?vue&type=script&lang=js"
export * from "./WidgetsDialogs.vue?vue&type=script&lang=js"
import style0 from "./WidgetsDialogs.vue?vue&type=style&index=0&id=648ad7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648ad7a0",
  null
  
)

export default component.exports